import store from '@/state/store';

export default function onMessageError(dataJson) {
  //if (store.state.rooms.selectedRoomId !== dataJson.body.chat_id) break;
  store.commit('room/ERROR_MESSAGES', {...dataJson.body, meta_id: dataJson.meta.id});
}
